export default "__VITE_ASSET__Dazh9q6N__"